module.exports = __webpack_public_path__ + "img/06.b67eea3b.jpg";